export default __webpack_public_path__ + "static/media/logo-B3.1dadd0f0.svg";